module.exports = __webpack_public_path__ + "stylesheets/section-horizontal-text-video_57ae8fa29157a2b70d0492f2cb1b76e7.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-horizontal-text-video.less
// module id = wwNa
// module chunks = 118